/**
 * Help Center Categories — Russian
 *
 * 8 категорий, соответствующих структуре Revolut
 */

import {
  AlertTriangle,
  ArrowDownToLine,
  ArrowUpFromLine,
  Percent,
  Receipt,
  Rocket,
  Shield,
  User,
} from "lucide-react";
import type { HelpCategory } from "../../types";

export const HELP_CATEGORIES_RU: HelpCategory[] = [
  {
    id: "getting-started",
    title: "Начало работы",
    description: "Всё, что нужно для старта с Supabank",
    icon: Rocket,
    order: 1,
  },
  {
    id: "account",
    title: "Аккаунт и профиль",
    description: "Управление настройками аккаунта",
    icon: User,
    order: 2,
  },
  {
    id: "deposits",
    title: "Депозиты и пополнение",
    description: "Как пополнить счёт криптовалютой",
    icon: ArrowDownToLine,
    order: 3,
  },
  {
    id: "withdrawals",
    title: "Выводы и выплаты",
    description: "Получение фиата на банковский счёт",
    icon: ArrowUpFromLine,
    order: 4,
  },
  {
    id: "transactions",
    title: "Транзакции",
    description: "Отслеживание и понимание операций",
    icon: Receipt,
    order: 5,
  },
  {
    id: "limits-fees",
    title: "Лимиты и комиссии",
    description: "Тарифы и ограничения",
    icon: Percent,
    order: 6,
  },
  {
    id: "security",
    title: "Безопасность",
    description: "Защита вашего аккаунта",
    icon: Shield,
    order: 7,
  },
  {
    id: "troubleshooting",
    title: "Решение проблем",
    description: "Ответы на частые вопросы",
    icon: AlertTriangle,
    order: 8,
  },
];

export function getCategoryByIdRu(id: string): HelpCategory | undefined {
  return HELP_CATEGORIES_RU.find((cat) => cat.id === id);
}
